export const SHOWS_ROUTE_NAMES = {
  LIST: 'shows-list',
  DETAIL: 'shows-detail',
  EDIT: 'shows-edit',
  CREATE: 'shows-create',
}
